import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
// import { CatComponentService } from "src/app/services/cat-component.service";
import { ToastrService } from 'ngx-toastr';
import { RoutesService } from './services/routes.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  isLoadingRoutes = true;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private routesService: RoutesService
  ) {}

  title='comisiones';
  
  //
  scrollToTop=()=> {
    window.scroll(0,0);
  }

  ngOnInit(): void {
    document.addEventListener("DOMContentLoaded", function(){
      window.addEventListener('scroll', function() {
          if (window.scrollY > 50) {
            document.getElementById('navbar_top').classList.add('fixed-top');
            document.getElementById('navbar_top').classList.add("backdrop-header");

            // add padding top to show content behind navbar
            let navbar_height = document.querySelector<HTMLElement>(".navbar").offsetHeight;
            document.body.style.paddingTop = navbar_height + 'px';
          } else {
            document.getElementById('navbar_top').classList.remove('fixed-top');
            document.getElementById('navbar_top').classList.remove("backdrop-header");
             // remove padding top from body
            document.body.style.paddingTop = '0';
          } 
      });
    });   
    // Cargar rutas dinámicamente al iniciar la app
    this.routesService.loadAndSetRoutes(this.router)
      .then(() => {
        this.isLoadingRoutes = false;
        // state: RouterStateSnapshot
        if (window.location.hash) {
          // Modo hash
          const hash = window.location.hash.substring(1);
          if (hash && hash !== '/') {
            this.router.navigateByUrl(hash);
          }
        } else {
          // Modo normal
          this.router.navigateByUrl(window.location.pathname);
        }
        console.log('App lista con rutas cargadas');
      })
      .catch(error => {
        this.isLoadingRoutes = false;
        console.error('Error inicializando rutas:', error);
      }); 
  }
}
